<template>
  <div class="loading-spinner-animation flex justify-center h-16 w-16">
    <img src="@/assets/img/loading.png" width="60" height="60" alt="" />
  </div>
</template>
